import { type JWT } from 'aws-amplify/auth'

import {
  authProviderAtom,
  type AuthProviderType,
  authStore
} from '@/features/auth/atoms'

import { LOCAL_STORAGE_ACCESS_TOKEN_KEY } from '../api/auth/constants'
import { fetchAuthSession } from '../auth/amplify'

const _authProviderType = {
  COGNITO: async () => {
    const session = await fetchAuthSession()
    return session?.tokens?.accessToken || null
  },
  AUTH0: async () => {
    return localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)
  }
} satisfies Record<AuthProviderType, () => Promise<string | JWT | null>>

const type = authStore.get(authProviderAtom)
export const fetchAccessToken = _authProviderType[type as AuthProviderType]
